import { Businesses } from '@just-in-types';
import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import generateManifest from './generateManifest';
import ErrorBoundary from './hoc/withErrorBoundary';
import { setBusinessId, SetBusinessId } from './store/actions';

interface IBusinessDispatchProps {
  onSetBusinessId: SetBusinessId;
}

interface IBusinessOwnProps {
  business: Businesses.Business;
  default?: boolean;
  path?: string;
}

type BusinessProps = IBusinessDispatchProps & IBusinessOwnProps;

class Business extends React.Component<BusinessProps> {
  public componentDidMount() {
    const {
      business: { businessId, path },
      onSetBusinessId,
    } = this.props;

    generateManifest(path);

    onSetBusinessId({ businessId });
  }

  public render() {
    const {
      business: { yardName },
    } = this.props;

    return (
      <ErrorBoundary>
        <React.Fragment>
          <Helmet>
            <title>{`${yardName} Kiosk`}</title>
          </Helmet>
          {this.props.children}
        </React.Fragment>
      </ErrorBoundary>
    );
  }
}

const mapDispatchToProps = {
  onSetBusinessId: setBusinessId,
};

// Only one default export per file
export default connect<null, IBusinessDispatchProps, IBusinessOwnProps>(
  null,
  mapDispatchToProps,
)(Business);



// WEBPACK FOOTER //
// ./src/Business.tsx